import api from "../../api/api";

export default function useErrorService(widgetName, traceLog) {

  async function sendConsoleLogEmail() {
    const dataMap = {
      from: "hello@heycarter.co.za",
      to: `Tristin.Cunningham@heycarter.co.za`,
      replyTo: "",
      subject: `${widgetName} - Trace log`,
      message: `
        Trace log: ${JSON.stringify(traceLog)}
      `
    }

    const emailResp = await api.sendEmail(dataMap);
    console.log('emailResp', emailResp);
    const isEmailSuccess = emailResp?.resultMessage === "Successfully saved";
    return isEmailSuccess;
  }

  return [sendConsoleLogEmail]
}
